import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { FiChevronLeft } from 'react-icons/fi';
import { FiChevronRight } from 'react-icons/fi';
import { useMemo } from 'react';

const PageHandler = observer(() => {
    const { matrixManager, viewManager, closetManager } = useMainContext();
    const currentPage =
        viewManager.selectedMenu === 2
            ? closetManager.selectedPageNo
            : matrixManager.selectedPageNo;
    const sortedPageNumbers = useMemo(() => {
        return viewManager.selectedPages
            .map((page) => Number(page.pageNum))
            .sort((a, b) => a - b);
    }, [viewManager.selectedPages]);
    const goToPreviousPage = async () => {
        if (viewManager.selectedMenu === 2) {
            const currentPage = closetManager.selectedPageNo;
            const totalPages = sortedPageNumbers.length;

            if (!totalPages) return;

            let currentIndex = sortedPageNumbers.indexOf(currentPage);
            if (currentIndex === -1) {
                closetManager.setIsLoading(false);
                return;
            }
            const prevIndex = (currentIndex - 1 + totalPages) % totalPages;
            const prevPageNum = sortedPageNumbers[prevIndex];

            closetManager.setIsLoading(true);
            viewManager.setActivePageNo(prevPageNum);
            await viewManager.bringChangesToClosetAccordingToSelectedPages();
            await closetManager.setSelectedPageNo(prevPageNum);
            await closetManager.fitToScreen();
            viewManager.updatePossibleClosets();
            closetManager.setIsLoading(false);
            return;
        }
        matrixManager.setIsLoading(true);
        await matrixManager.setSelectedPageNo(
            ((currentPage - 2 + matrixManager.pdfDoc.numPages) %
                matrixManager.pdfDoc.numPages) +
                1,
        );
        await matrixManager.fitToScreen();
        matrixManager.setIsLoading(false);
    };

    const goToNextPage = async () => {
        if (viewManager.selectedMenu === 2) {
            const currentPage = closetManager.selectedPageNo;
            const totalPages = sortedPageNumbers.length;

            if (!totalPages) return;

            let currentIndex = sortedPageNumbers.indexOf(currentPage);

            if (currentIndex === -1) {
                closetManager.setIsLoading(false);
                return;
            }
            const nextIndex = (currentIndex + 1) % totalPages;
            const nextPageNum = sortedPageNumbers[nextIndex];

            closetManager.setIsLoading(true);
            viewManager.setActivePageNo(nextPageNum);
            await viewManager.bringChangesToClosetAccordingToSelectedPages();
            await closetManager.setSelectedPageNo(nextPageNum);
            await closetManager.fitToScreen();
            viewManager.updatePossibleClosets();
            closetManager.setIsLoading(false);
            return;
        }
        matrixManager.setIsLoading(true);
        await matrixManager.setSelectedPageNo(
            ((currentPage - 1 + 1) % matrixManager.pdfDoc.numPages) + 1,
        );
        await matrixManager.fitToScreen();
        matrixManager.setIsLoading(false);
    };

    return (
        <div className="bg-theme-white  rounded-[100px] flex items-center gap-[16px]">
            <button
                className="w-[32px] h-[32px] rounded-full bg-theme-header-bg text-theme-black hover:bg-theme-orange cursor-pointer hover:text-white transition-all flex justify-center items-center "
                onClick={goToPreviousPage}
                title="Previous Page">
                <FiChevronLeft className="text-[22px]" />
            </button>
            <div className="text-[14px] font-medium w-[54px] text-center">
                Page {currentPage}
            </div>
            <button
                className="w-[32px] h-[32px] rounded-full bg-theme-header-bg text-theme-black hover:bg-theme-orange cursor-pointer hover:text-white transition-all flex justify-center items-center "
                onClick={goToNextPage}
                title="Next Page">
                <FiChevronRight className="text-[22px]" />
            </button>
        </div>
    );
});

export default PageHandler;
